// extracted by mini-css-extract-plugin
export var fadeIn = "_gw-1";
export var modalContent = "_gw-3";
export var overlay = "_gw-0";
export var popoverContent = "_gw-2";
export var results = "_gw-5";
export var searchInputWrapper = "_gw-4";